/* eslint-disable react/function-component-definition */
import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faEdit } from "@fortawesome/free-solid-svg-icons"; // Added faEdit for edit button
import { Entry } from "../../redux/entrySlice";
import SelectBox from "../../components/SelectBox/SelectBox";
import PhoneNumberInput from "../../components/PhoneNumberBox/PhoneNumberBox";
import styles from "./editUserPopUp.module.scss";
import { TableContext } from "../../contexts/tableContext";
import MultipleFileUpload from "../../components/MultipleFileUpload/MultipleFileUpload";
import "react-toastify/dist/ReactToastify.css";
import TextInput from "../../components/TextField/TextField";
import EmailInput from "../../components/EmailBox/EmailBox";
import { REACT_APP_API_ROLES_DROPDOWN } from "../../redux/apiConstants";
import { Image } from "react-bootstrap";
import PasswordField from "../../components/PasswordField/PasswordField";
import { getCookies } from "../../hooks/useCookies";
import Loader from '../../components/Loader/Loader';

const COUNTRY_CODES = [
  { label: "+1 (US/Canada)", value: "+1" },
  { label: "+7 (Russia)", value: "+7" },
  { label: "+20 (Egypt)", value: "+20" },
  { label: "+27 (South Africa)", value: "+27" },
  { label: "+30 (Greece)", value: "+30" },
  { label: "+31 (Netherlands)", value: "+31" },
  { label: "+32 (Belgium)", value: "+32" },
  { label: "+33 (France)", value: "+33" },
  { label: "+34 (Spain)", value: "+34" },
  { label: "+36 (Hungary)", value: "+36" },
  { label: "+39 (Italy)", value: "+39" },
  { label: "+40 (Romania)", value: "+40" },
  { label: "+41 (Switzerland)", value: "+41" },
  { label: "+43 (Austria)", value: "+43" },
  { label: "+44 (United Kingdom)", value: "+44" },
  { label: "+45 (Denmark)", value: "+45" },
  { label: "+46 (Sweden)", value: "+46" },
  { label: "+47 (Norway)", value: "+47" },
  { label: "+48 (Poland)", value: "+48" },
  { label: "+49 (Germany)", value: "+49" },
  { label: "+51 (Peru)", value: "+51" },
  { label: "+52 (Mexico)", value: "+52" },
  { label: "+53 (Cuba)", value: "+53" },
  { label: "+54 (Argentina)", value: "+54" },
  { label: "+55 (Brazil)", value: "+55" },
  { label: "+56 (Chile)", value: "+56" },
  { label: "+57 (Colombia)", value: "+57" },
  { label: "+58 (Venezuela)", value: "+58" },
  { label: "+60 (Malaysia)", value: "+60" },
  { label: "+61 (Australia)", value: "+61" },
  { label: "+62 (Indonesia)", value: "+62" },
  { label: "+63 (Philippines)", value: "+63" },
  { label: "+64 (New Zealand)", value: "+64" },
  { label: "+65 (Singapore)", value: "+65" },
  { label: "+66 (Thailand)", value: "+66" },
  { label: "+81 (Japan)", value: "+81" },
  { label: "+82 (South Korea)", value: "+82" },
  { label: "+84 (Vietnam)", value: "+84" },
  { label: "+86 (China)", value: "+86" },
  { label: "+90 (Turkey)", value: "+90" },
  { label: "+91 (India)", value: "+91" },
  { label: "+92 (Pakistan)", value: "+92" },
  { label: "+93 (Afghanistan)", value: "+93" },
  { label: "+94 (Sri Lanka)", value: "+94" },
  { label: "+95 (Myanmar)", value: "+95" },
  { label: "+98 (Iran)", value: "+98" },
  { label: "+212 (Morocco)", value: "+212" },
  { label: "+213 (Algeria)", value: "+213" },
  { label: "+216 (Tunisia)", value: "+216" },
  { label: "+218 (Libya)", value: "+218" },
  { label: "+220 (Gambia)", value: "+220" },
  { label: "+221 (Senegal)", value: "+221" },
  { label: "+234 (Nigeria)", value: "+234" },
  { label: "+254 (Kenya)", value: "+254" },
  { label: "+256 (Uganda)", value: "+256" },
  { label: "+260 (Zambia)", value: "+260" },
  { label: "+263 (Zimbabwe)", value: "+263" },
  { label: "+351 (Portugal)", value: "+351" },
  { label: "+352 (Luxembourg)", value: "+352" },
  { label: "+353 (Ireland)", value: "+353" },
  { label: "+354 (Iceland)", value: "+354" },
  { label: "+358 (Finland)", value: "+358" },
  { label: "+380 (Ukraine)", value: "+380" },
  { label: "+381 (Serbia)", value: "+381" },
  { label: "+385 (Croatia)", value: "+385" },
  { label: "+386 (Slovenia)", value: "+386" },
  { label: "+420 (Czech Republic)", value: "+420" },
  { label: "+421 (Slovakia)", value: "+421" },
  { label: "+966 (Saudi Arabia)", value: "+966" },
  { label: "+971 (UAE)", value: "+971" },
  { label: "+972 (Israel)", value: "+972" },
  { label: "+973 (Bahrain)", value: "+973" },
  { label: "+974 (Qatar)", value: "+974" },
  { label: "+975 (Bhutan)", value: "+975" },
  { label: "+976 (Mongolia)", value: "+976" },
  { label: "+977 (Nepal)", value: "+977" },
  { label: "+994 (Azerbaijan)", value: "+994" },
  { label: "+995 (Georgia)", value: "+995" },
  { label: "+996 (Kyrgyzstan)", value: "+996" },
  { label: "+998 (Uzbekistan)", value: "+998" },
];

const EditUserPopup = React.memo(
  ({ userId, handleClose, setIsUpdated, edit = true }) => {
    const [submitting, setSubmitting] = useState(false);
    const { formthemeStyle, bodyheader, viewformStyle } =
      useContext(TableContext);
    const [user, setUser] = useState([]);
    const [error, setError] = useState(null);
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isEditMode, setIsEditMode] = useState(false);
    const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
    const isSuperAdmin = getCookies("ISSUPERADMIN") === "true";
    const dispatch = useDispatch();
    const { files } = useContext(TableContext);
    const {
      control,
      register,
      handleSubmit,
      formState: { errors },
      reset,
    } = useForm();

    useEffect(() => {
      setLoading(true);
      const url2 = REACT_APP_API_ROLES_DROPDOWN; // api url
      fetch(url2)
        .then((resp) => resp.json())
        .then((resp) => {
          setRoles(resp.data.role.selectdata);
        });

      const actionData = {
        actionUrl: `adminuser/${userId}`,
        actionMethod: "get",
      };
      dispatch(Entry(actionData)).then((resp) => {
        if (resp.payload && resp.payload.data && resp.payload.data.user) {
          const userData = resp.payload.data.user;
          console.log("userData==", userData);
          setUser(userData);
          setTwoFactorEnabled(userData.twoFactorEnabled || false);
          reset(userData);
          setLoading(false);
        } else {
          console.error("User data not found in response:", resp);
          setUser(null);
        }
      });
    }, [userId]);

    const onSubmitdata = (data) => {
      if (data.name.trim().length === 0) {
        document.getElementById("name").focus();
      } else {
        setSubmitting(true);
        setError(null);
        const apiData = {
          name: data.name,
          email: data.email,
          File: files,
        };

        if (typeof data.role === "string" || typeof data.role === "number") {
          apiData.role = data.role;
        }

        if (isSuperAdmin) {
          apiData.twoFactorEnabled = twoFactorEnabled;
          if (twoFactorEnabled) {
            apiData.phone = data.phone || user.phone;
            apiData.countryCode = data.countryCode || user.countryCode;
          }
        }
        if (data.password) {
          apiData.password = data.password;
        }
        data.actionUrl = `adminuser/${userId}`;
        data.actionMethod = "patch";
        data.apiData = apiData;
        dispatch(Entry(data)).then((resp) => {
          setSubmitting(false);
          if (resp.payload.code === 200) {
            toast.success("User details updated successfully");
            setIsEditMode(false);
            handleClose();
            setIsUpdated(true);
          } else {
            setError(resp.payload.message);
            toast.error("Error updating user details");
          }
        });
      }
    };

    return (
      <div className={styles.popupbox}>
        <div className={styles.box} id={styles.box}>
          {/* Flex container for close button, heading, and edit button */}
          <div className="d-flex align-items-center gap-3">
            <button
              className={styles.closeicon}
              aria-label="Close"
              onClick={handleClose}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
            {/* Conditionally render the heading based on isEditMode */}
            {user.image && !isEditMode && (
              <Image
                src={user.image}
                alt="logo"
                className={styles.profilepic}
              />
            )}
            <h2 className={styles.heading}>
              {isEditMode ? "Edit User Details" : "User Details"}
            </h2>

            {/* Show edit button only when not in edit mode */}
            {!isEditMode && edit && (
              <button
                className={`${styles.formbtnedit}`} // Add your custom class for styling
                onClick={() => setIsEditMode(true)}
                aria-label="Edit"
              >
                <FontAwesomeIcon icon={faEdit} /> {/* Edit icon */}
                Edit
              </button>
            )}
          </div>

          <div className="container-fluid mt-5 edituserform">
            {loading ? (
              <div className="text-center mt-5">
                <Loader />
                <p>Loading user data...</p>
              </div>
            ) : user ? (
              <form onSubmit={handleSubmit(onSubmitdata)}>
                <div className={`row ${styles.profilepicdiv}`}></div>
                <div className="row">
                  <div className="col-md-6 col-sm-6">
                    <TextInput
                      className={
                        isEditMode
                          ? styles.inputboxedit
                          : styles.inputboxnotedit
                      }
                      label="Name"
                      fieldName="name"
                      placeHolder="Enter Name"
                      register={register}
                      errors={errors}
                      isRequired
                      mandatory
                      maximLength="50"
                      readOnly={!isEditMode} // Disable input when not in edit mode
                    />
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <EmailInput
                      className={
                        isEditMode
                          ? styles.inputboxedit
                          : styles.inputboxnotedit
                      }
                      label="Email"
                      fieldName="email"
                      register={register}
                      errors={errors}
                      isRequired
                      mandatory
                      placeHolder="Email"
                      readOnly={!isEditMode} // Disable input when not in edit mode
                    />
                  </div>
                </div>
                <div className="row">
                  {/* Phone Number Input */}
                  <div className="col-md-6 col-sm-6">
                    {isEditMode ? (
                      <SelectBox
                        className={styles.inputbox}
                        classNamedark={styles.inputbox1}
                        name="role"
                        label="Role"
                        labelstyle={styles.formlabel}
                        defaultvalue={user?.role?.id}
                        control={control}
                        register={register}
                        values={roles}
                        errors={errors}
                        placeholder="Choose Role"
                        mandatory
                        Disabled={!isEditMode}
                      />
                    ) : (
                      <>
                        <label>Role</label>
                        <input
                          className={
                            isEditMode
                              ? styles.inputboxedit
                              : styles.inputboxnotedit
                          }
                          label="Role"
                          fieldName="role"
                          defaultValue={user?.role?.name}
                          // placeHolder="Enter Name"
                          // register={register}
                          // errors={errors}
                          // isRequired
                          // mandatory
                          maximLength="50"
                          readOnly={!isEditMode} // Disable input when not in edit mode
                        />
                      </>
                    )}
                  </div>

                  {isEditMode && (
                    <div className="col-md-6 col-sm-6">
                      <PasswordField
                        fieldName="password"
                        classNamedark={styles.inputbox1}
                        // labelstyle={styles.formlabel}
                        label="Password"
                        register={register}
                        errors={errors}
                        placeHolder="Enter Password"
                        // isRequired
                        minimLength={8}
                        eyeiconstyle={styles.eyeicon}
                        className={styles.emailbox}
                        labelstyle={styles.labeltext}
                        // mandatory
                      />
                    </div>
                  )}

                  {/* User Type */}
                  {/* <div className="col-md-6 col-sm-6">
                  <label>User Type</label>
                  <div className={`${styles.inputbox} ${isEditMode ? `${styles.boxDisabled}` : ''}`}>
                    <div className={`${styles.userTypeValue}`}>
                      <span>{user.userType || "N/A"}</span>
                    </div>
                  </div>
                </div> */}
                </div>

                {isSuperAdmin && (
                  <>
                    <div className="row mt-3">
                      <div className="col-md-6 col-sm-6">
                        <div className="form-group">
                          <label className={styles.formlabel || styles.labeltext}>
                            Two-Factor Authentication
                          </label>
                          <div className="d-flex align-items-center gap-2 mt-1">
                            <input
                              className="form-check-input m-0"
                              type="checkbox"
                              role="switch"
                              id="twoFactorToggle"
                              checked={twoFactorEnabled}
                              onChange={(e) =>
                                setTwoFactorEnabled(e.target.checked)
                              }
                              disabled={!isEditMode}
                              aria-label="Enable Two-Factor Authentication"
                              tabIndex={0}
                            />
                            <label
                              className="form-check-label m-0"
                              htmlFor="twoFactorToggle"
                            >
                              {twoFactorEnabled ? "Enabled" : "Disabled"}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    {twoFactorEnabled && isEditMode && (
                      <div className="row mt-2">
                        <div className="col-md-6 col-sm-6">
                          <SelectBox
                            className={styles.inputbox}
                            classNamedark={styles.inputbox1}
                            name="countryCode"
                            label="Country Code"
                            labelstyle={styles.formlabel || styles.labeltext}
                            defaultvalue={user?.countryCode}
                            control={control}
                            register={register}
                            values={COUNTRY_CODES}
                            errors={errors}
                            placeholder="Select country code"
                            mandatory
                            Disabled={!isEditMode}
                          />
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <PhoneNumberInput
                            className={
                              isEditMode
                                ? styles.inputboxedit
                                : styles.inputboxnotedit
                            }
                            labelstyle={styles.formlabel || styles.labeltext}
                            label="2FA Phone Number"
                            fieldName="phone"
                            register={register}
                            errors={errors}
                            isRequired
                            mandatory
                            readOnly={!isEditMode}
                          />
                        </div>
                      </div>
                    )}
                    {twoFactorEnabled && !isEditMode && user.phone && (
                      <div className="row mt-2">
                        <div className="col-md-6 col-sm-6">
                          <label>2FA Phone</label>
                          <input
                            className={styles.inputboxnotedit}
                            defaultValue={`${user.countryCode || ""} ${user.phone || ""}`}
                            readOnly
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}

                {isEditMode && (
                  <div className={`row ${styles.fileContainer}`}>
                    <div className="col-md-6 col-sm-6">
                      <MultipleFileUpload
                        editFiles={user.image}
                        section="user"
                        disabled={!isEditMode}
                        register={register}
                        errors={errors}
                      />
                    </div>
                  </div>
                )}
                {/* Submit button visible only in edit mode */}
                {isEditMode && (
                  <div className={styles.btnContainer}>
                    <input
                      className={styles.formbtn}
                      type="submit"
                      disabled={submitting}
                      value={submitting ? "Please wait.." : "Update"}
                    />
                  </div>
                )}

                {error && <h6 className={styles.errormsg}>{error}</h6>}
              </form>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "130px",
                  color: "#39979d",
                }}
              >
                <Loader />
                <p>No user data found</p>
              </div>
            )}

            {/* <ToastContainer autoClose={2000} /> */}
          </div>
        </div>
      </div>
    );
  }
);

export default EditUserPopup;
